import { render, staticRenderFns } from "./dichiarazioniMobile.vue?vue&type=template&id=42ec3561&scoped=true&"
import script from "./dichiarazioniMobile.vue.ts?vue&type=script&lang=ts&"
export * from "./dichiarazioniMobile.vue.ts?vue&type=script&lang=ts&"
import style0 from "./dichiarazioniMobile.vue?vue&type=style&index=0&id=42ec3561&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42ec3561",
  null
  
)

export default component.exports